export type ActivityType = 'PLEASE_WAIT' | 'FETCHING_PRODUCTS' | 'IDLE';

export const ACTIVITY_TYPE_IDLE = 'IDLE';
export const ACTIVITY_TYPE_PLEASE_WAIT = 'PLEASE_WAIT';
export const ACTIVITY_TYPE_FETCHING_PRODUCTS = 'FETCHING_PRODUCTS';
